<template>
    <div class="HotColumn">
        <div class="title">{{info.nTitle}}</div>
        <div class="time">{{info.displayTime}}</div>
        <div class="text" v-html="info.nContent"></div>
    </div>
</template>
<script>
import http from "../../../service/http";
export default {
    name:'HotColumn',
    data(){
        return{
            info:[],
        }
    },
    mounted(){
        this.get_detail();
    },
    methods:{
        get_detail(){
            var that=this;
            var userGuid=http.getQueryString('userGuid');
            var nid=http.getQueryString('nid')
            var data={
                cmd:'GetXYHNewsInfoById',
                userGuid:userGuid,
                nid:nid
            }
            http.req(data,function(res){
                that.info=res.info
            },'https://apinew.koalaknow.com/api/AlumniAssociationRequestHandle/InterfaceV1')
        }
    }
}
</script>
<style scoped>
.HotColumn{
    background: #fff;
    padding: 55px 40px 60px;
    box-sizing: border-box;
    color: #333333;
}
.title{
    font-size: 36px;
    font-weight: bold;
    line-height: 48px;
}
.time{
    color: #999999;
    font-size: 24px;
    line-height: 60px;
}
.text{
    margin: 30px 0 0 0;
    font-size: 24px;
    line-height: 48px;
}
.text >>> *{
    max-width: 100%!important;
}
</style>


// WEBPACK FOOTER //
// src/components/App/Hot_Column.vue